import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { getIsLoggedIn } from '@wix/da-shared-react/pkg/publicSession/selectors';
import { restrictLoggedOut } from '@wix/da-shared-react/pkg/redux/loggedout';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import {
  isCurrentUserProfileOwner,
  getProfileOwnerUser,
} from '../../../selectors/users';
import { getShopItemsStreamId } from '../../../streams/shop';
import { ShopItemType } from '../../../../types/shop';
import { AppState } from '../../../../types/store';
import { selectors as streamSelectors } from '@wix/da-shared-react/pkg/Stream';
import { actions as modalActions } from '@wix/da-shared-react/pkg/Modals';
import { ModalType } from '@wix/da-shared-react/pkg/Modals/redux/types';
import { Props } from './ShopSection';

type StateProps = Pick<Props, 'profileOwnerUser' | 'isOwner' | 'isLoggedIn' | 'total'>;
type DispatchProps = Pick<Props, 'openCommissionModal' | 'restrictLoggedOut'>;
type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => {
  const commissionsTotal = streamSelectors.getTotal(
    state,
    getShopItemsStreamId(ShopItemType.COMMISSIONS)
  );
  const premiumContentTotal = streamSelectors.getTotal(
    state,
    getShopItemsStreamId(ShopItemType.PREMIUM_CONTENT)
  );
  const printsTotal = streamSelectors.getTotal(
    state,
    getShopItemsStreamId(ShopItemType.PRINTS)
  );
  const premiumFoldersTotal = streamSelectors.getTotal(
    state,
    getShopItemsStreamId(ShopItemType.PREMIUM_FOLDERS)
  );
  const dasTotal = streamSelectors.getTotal(
    state,
    getShopItemsStreamId(ShopItemType.DAS)
  );

  const allTotal =
    commissionsTotal +
    premiumContentTotal +
    printsTotal +
    premiumFoldersTotal +
    dasTotal;

  return {
    profileOwnerUser: getProfileOwnerUser(state),
    isOwner: isCurrentUserProfileOwner(state),
    isLoggedIn: getIsLoggedIn(state),
    total: {
      all: isNaN(allTotal) ? 0 : allTotal,
      commissions: commissionsTotal,
      premiumContent: premiumContentTotal,
      prints: printsTotal,
      premiumFolders: premiumFoldersTotal,
      das: dasTotal,
    },
  };
};

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  openCommissionModal: () =>
    modalActions.pushModal(ModalType.COMMISSION, {
      wrapInModal: false,
    }),
  restrictLoggedOut: () =>
    restrictLoggedOut({ restrictedActionName: ReferralType.CREATE_COMMISSION }),
};

export default connect(mapStateToProps, mapDispatchToProps);
